'use strict';
//signalrService MIGRADO Y TESTEADO
angular.module('TurneroApp').component('coEstadoPuestosSalon', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'puestosService',
        'utilsService',
        '$interval',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        '$state',
        '$scope',
        function (puestosService, utilsService, $interval, signalrService, TurneroAppConstant, $state, $scope) {
            var ctrl = this;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.disableLiberar = false;

            ctrl.limpiarMemoria = function () {
                ctrl.puestosCentro = [];
            };

            //el onChange se ejecuta cada vez que cambian los parametros unidireccionales del binding 
            ctrl.$onChanges = function () {
                if (ctrl.centroAtencionSeleccionado.id) {
                    ctrl.getPuestos();

                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        //NO UTILIZAR FUNCIONES ANÓNIMAS AL REGISTRAR UN HANDLER PORQUE SINO SE AGREGA UN ITEM NUEVO AL ARRAY DE HANDLERS CADA VEZ
                        //QUE PASA EL CÓDIGO POR EL "on" Y LUEGO SE MULTIPLICA LA EJECUCIÓN DEL MISMO CÓDIGO ANTE UNA SÓLA NOTIFICACIÓN DEL EVENTO
                        hub.on("TraerPuestos", ctrl.traerPuestos);

                        //se llama cuando se quiere actualizar un unico puesto
                        hub.on("MostrarPuesto", ctrl.onMostrarPuesto);
                    }).catch(function (err) {
                        console.error(err.toString());

                        //si no se pudo conectar al hub en primera instancia activo las acciones temporizadas
                        ctrl.activarAccionesTemporizadas();
                    });
                }
            };

            ctrl.$onDestroy = function () {
                //cuando el componente se destruye se cancela el interval
                if (ctrl.intervalAccionesTemporizadas)
                    $interval.cancel(ctrl.intervalAccionesTemporizadas);
            };

            //Esto está sólo a modo de ejemplo, a futuro se puede colocar en un lugar global para mantener al tanto al usuario sobre las conexiones/reconexiones...
            $scope.$on('BeforeHubConnectionStart', function (event, hub) {
                if (hub.connection.baseUrl.indexOf(TurneroAppConstant.HubNames.PUESTOS) !== -1
                /*&& !hub.methods.traerpuestos*/) {
                    console.info("Broadcast 'BeforeHubConnectionStart' recibido para SignalR connection " + TurneroAppConstant.HubNames.PUESTOS + ".");
                }
            })

            //Esto se hace ÚNICAMENTE para los Components que necesitan SER NOTIFICADOS, NO así para los Components que sólo invocan.
            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                if (hub.connection.baseUrl.indexOf(TurneroAppConstant.HubNames.PUESTOS) !== -1) {
                    hub.invoke('AgregarGrupo', ctrl.centroAtencionSeleccionado.id).then(function () {
                        console.info("Se invocó a AgregarGrupo en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                    }).catch(function (err) {
                        console.error("Falló invocación a AgregarGrupo en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                    });
                }

                //cuando se conecta al hub desactivo las acciones temporizadas
                ctrl.desactivarAccionesTemporizadas();
            });

            //cuando se desconecta el hub realizo las acciones temporizadas
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.activarAccionesTemporizadas();
            });

            ctrl.traerPuestos = function (id_centro_atencion) {
                console.info("Se notificó TraerPuestos desde " + TurneroAppConstant.HubNames.PUESTOS + ".");
                if (ctrl.centroAtencionSeleccionado.id == id_centro_atencion) {
                    utilsService.swalNotification('Procesando', 'Obteniendo puestos del salón', 'info');
                    ctrl.getPuestos();
                }
            };

            ctrl.onMostrarPuesto = function (puesto) {
                let indx = ctrl.puestosCentro.findIndex(x => x.Id_Puesto == puesto.Id_Puesto);

                if (indx > -1) {
                    ctrl.puestosCentro[indx] = puesto;
                }
                else {
                    ctrl.puestosCentro.push(puesto);
                }

                ctrl.disableLiberar = ctrl.validar_Turnos_Ocupados();
            };

            ctrl.liberarPuesto = function (puesto) {
                utilsService.swalNotification('Procesando', 'Liberando puesto: ' + puesto.N_Puesto, 'info')

                puestosService.Put_Puesto_Liberar(puesto.Id_Usuario_Sesion).$promise.then(function (data) {
                    swal.close();

                    //actualizo los turnos asignados al centro de atencion
                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('TraerTurnos', ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a TraerTurnos en " + TurneroAppConstant.HubNames.TURNOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnos en " + TurneroAppConstant.HubNames.TURNOS + ": " + err.toString());
                        });
                    });

                    //actualizo el estado del puestos
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, puesto.Id_Puesto).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    swal({
                        title: "Liberar Puesto",
                        text: "El puesto se liberó correctamente!",
                        type: "success",
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                    })
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.validar_Turnos_Ocupados = function () {
                for (var i = 0; i < ctrl.puestosCentro.length; i++) {
                    if (ctrl.puestosCentro[i].Estado != 'Disponible') {
                        return false;
                    }
                }
                return true;
            }

            ctrl.liberarPuestos = function (id_centro) {
                utilsService.swalNotification('Procesando', 'Liberando los puestos de atención', 'info')
                puestosService.Put_Puestos_Liberar(id_centro).$promise.then(function (data) {
                    swal.close();

                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('TraerTurnos', ctrl.centroAtencionSeleccionado.id);
                    });

                    //actualizo el estado de los puestos
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuestos', ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a TraerPuestos en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuestos en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    swal({
                        title: "Liberar Puestos",
                        text: "Los puestos se liberaron correctamente!",
                        type: "success",
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                    })
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.getPuestos = function () {
                utilsService.swalNotification('Procesando', 'Obteniendo puestos del salón', 'info');

                ctrl.limpiarMemoria();

                puestosService.Get_Puesto_Estado_Supervision({ 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (data) {
                    ctrl.puestosCentro = data.Data.Puestos;

                    ctrl.disableLiberar = ctrl.validar_Turnos_Ocupados();

                    swal.close();
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.validarTiempoDeAtencion = function () {
                if (ctrl.puestosCentro && ctrl.puestosCentro.length) {
                    for (var i = 0; i < ctrl.puestosCentro.length; i++) {

                        ctrl.puestosCentro[i].TiempoAtencion = moment().diff(moment(ctrl.puestosCentro[i].Fecha_Atencion, "DD/MM/YYYY HH:mm:ss"), 'minutes');
                    }
                }
            };

            ctrl.accionesTemporizadas = function () {
                ctrl.getPuestos();
            }

            ctrl.activarAccionesTemporizadas = function () {
                //este if está para que se cree un solo interval y pueda ser capturado para luego cerrarse
                if (!ctrl.intervalAccionesTemporizadas) {
                    ctrl.intervalAccionesTemporizadas = $interval(ctrl.accionesTemporizadas, TurneroAppConstant.HubDisconnectedIntervals.Atencion);
                }
            }

            ctrl.desactivarAccionesTemporizadas = function () {
                if (ctrl.intervalAccionesTemporizadas) {
                    //cancelo el interval
                    $interval.cancel(ctrl.intervalAccionesTemporizadas);
                    ctrl.intervalAccionesTemporizadas = undefined;

                    //llamo por ultima vez a las acciones para que queden actualizadas
                    ctrl.accionesTemporizadas();
                }
            }

            function tick() {
                if ($state.$current.name != "admin.puestosSalon") {
                    $interval.cancel(ctrl.ticker);
                } else {
                    ctrl.validarTiempoDeAtencion();
                }
            }
            tick();
            ctrl.ticker = $interval(tick, 1000);
        }],
    template: require('./estadoPuestos.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/estadosPuestosComponent.js